import lt_LT_meta from '@custom/meta/lt_LT.json';
import { combineCustomPageMetaData } from '@root/modules/custom-page/utils/customPageMetaDataUtils';

export default function (locale: string, path: string): { title: string; description: string } {
  const meta = lt_LT_meta;
  const pageMeta = combineCustomPageMetaData(meta, path);

  return {
    title: pageMeta.find((s: any) => s.hid === 'title')?.content || '',
    description: pageMeta.find((s: any) => s.hid === 'description')?.content || '',
  };
}
